// removed by extract-text-webpack-plugin
module.exports = {"icon":"Icon__icon___3SpCA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.css
// module id = 1184
// module chunks = 55